module.exports = __webpack_public_path__ + "static/leader4-bbec9082b93cf40d970a1f4a9f266dc2.svg";